// extracted by mini-css-extract-plugin
export var bottomFooter = "layout-module--bottomFooter--1S8ne";
export var copy = "layout-module--copy--fupYu";
export var flexThird = "layout-module--flexThird--z3kp7";
export var footerHeading = "layout-module--footerHeading--QHOag";
export var footerSubtext = "layout-module--footerSubtext--3L1fQ";